var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShimentlabel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.074 12.713a.746.746 0 0 1-.74-.74V4.073c0-.405.336-.74.74-.74.405 0 .74.335.74.74v7.898c0 .405-.335.74-.74.74zM5.037 8.763a.746.746 0 0 1-.74-.74v-3.95c0-.404.336-.74.74-.74.405 0 .74.336.74.74v3.95c0 .405-.335.74-.74.74z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.037 12.712a.746.746 0 0 1-.74-.74v-.987c0-.405.336-.741.74-.741.405 0 .74.336.74.74v.988c0 .405-.335.74-.74.74zM10.96 5.802a.746.746 0 0 1-.741-.74v-.988c0-.405.335-.74.74-.74.405 0 .74.335.74.74v.987c0 .405-.335.74-.74.74z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.996 12.713a.746.746 0 0 1-.74-.74v-7.9c0-.404.336-.74.74-.74.405 0 .74.336.74.74v7.9c0 .404-.335.74-.74.74zM10.96 12.713a.746.746 0 0 1-.741-.74v-3.95c0-.405.335-.74.74-.74.405 0 .74.335.74.74v3.95c0 .404-.335.74-.74.74zM13.928 12.713a.746.746 0 0 1-.74-.74v-7.9c0-.404.335-.74.74-.74.405 0 .74.336.74.74v7.9c0 .404-.335.74-.74.74z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShimentlabel);
export default __webpack_public_path__ + "static/media/shimentlabel.0544a41d959e75a22ec15bc8afc6efe8.svg";
export { ForwardRef as ReactComponent };